"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COPY_LINK_INPUT_WITH_BUTTON = void 0;
const COPY_LINK_INPUT_WITH_BUTTON = exports.COPY_LINK_INPUT_WITH_BUTTON = 'copy-link-input-with-button';
//# sourceMappingURL=constants.js.map